var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"split_page"},[_c('div',{staticClass:"nav",on:{"click":_vm.hideFn}},[_vm._v("返回模板列表页")]),_vm._v(" "),_c('ul',{staticClass:"list_content clearfix"},_vm._l((_vm.itemSet),function(item,key){return _c('li',{key:key,domProps:{"innerHTML":_vm._s(item)},on:{"click":function($event){return _vm.electFn(item)}}})}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fe011056","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/com-splitpage.vue
// module id = null
// module chunks = 